module.exports = __webpack_public_path__ + "img/UTGREE-2.2baa679a.jpg";